//
// Private Storage Utilities
//

const canUseBrowserStorage = function() {
    try {
        localStorage.setItem('store', '1');
        localStorage.removeItem('store');
        sessionStorage.setItem('store', '1');
        sessionStorage.removeItem('store');

        return true;
    } catch (error) {
        return false;
    }
};

const checkStorageType = function(storage_type) {
    var storage_enabled = canUseBrowserStorage();

    // Fall back to cookies for Safari Private Browsing
    if(!storage_enabled) {
        storage_type = 'cookie';
    }

    return storage_type;
};


//
// Public Storage Utilities
//

export const setStorage = function(storage_type, storage_key, storage_value, storage_expiry) {
    var safe_storage_type = checkStorageType(storage_type);

    switch(safe_storage_type) {
        case 'local':
            setLocalStorage(storage_key, storage_value);
            break;
        case 'session':
            setSessionStorage(storage_key, storage_value);
            break;
        case 'cookie':
            // Apply blanket expiry if original storage type is local
            if(storage_type === 'local') {
                storage_expiry = 7;
            }

            // If no expiry sent (session storage, session cookies) 
            // then setCookie will handle this
            setCookie(storage_key, storage_value, storage_expiry);
    }
};

export const getStorage = function(storage_type, storage_key) {
    var safe_storage_type = checkStorageType(storage_type);

    switch(safe_storage_type) {
        case 'local':
            return getLocalStorage(storage_key);
        case 'session':
            return getSessionStorage(storage_key);
        case 'cookie':
            return getCookie(storage_key);
        case 'find_cookie':
            return findCookie(storage_key);
    }
};

export const deleteStorage = function(storage_type, storage_key, cookie_domain) {
    var safe_storage_type = checkStorageType(storage_type);

    switch(safe_storage_type) {
        case 'local':
            deleteLocalStorage(storage_key);
            break;
        case 'session':
            deleteSessionStorage(storage_key);
            break;
        case 'cookie':
            deleteCookie(storage_key, cookie_domain);
            break;
    }
};

export const clearStorage = function(storage_type) {
    var safe_storage_type = checkStorageType(storage_type);

    switch(safe_storage_type) {
        case 'local':
            clearLocalStorage();
            break;
        case 'session':
            clearSessionStorage();
            break;
        case 'cookie':
            clearCookies();
            break;
    }
};

export const isObjectValid = function(stored_object, age) {
    var right_now = new Date().getTime();
    var time_passed = right_now - (age * 1000);

    if(typeof(stored_object['timestamp']) === 'undefined') {
        return false;
    }

    if(stored_object['timestamp'] > time_passed) {
        return true;
    }
    
    return false;
};


//
// Cookie Storage
//

const setCookie = function(cookie_name, cookie_value, days_active) {
    var cookie_entry = cookie_name + '=' + encodeURIComponent(cookie_value) + ';';
    
    if(typeof(days_active) === 'undefined') {
        // Session cookie
        document.cookie = cookie_entry + '; path=/;';
    } else {
        // Timed cookie
        var right_now = new Date();
        right_now.setTime(right_now.getTime() + days_active * 24 * 60 * 60 * 1000);
    
        var expiry_time = 'expires=' + right_now.toUTCString();
        document.cookie = cookie_entry + expiry_time + '; path=/;';
    }
};

const getCookie = function(cookie_name) {
    var filtered_jar = findCookie(cookie_name);
    var target = cookie_name + '=';

    if(filtered_jar.length > 0) {
        var chosen_cookie = filtered_jar[0].trim();
        return chosen_cookie.substring(target.length, chosen_cookie.length);
    } else {
        return '';
    }
};

const findCookie = function(cookie_name) {
    var target = cookie_name + '=';
    var cookie_jar = decodeURIComponent(document.cookie).split(';');

    return cookie_jar.filter(function (cookie, index) {
        var current = cookie.trim();
        var match_index = current.indexOf(target);

        if(match_index === 0) {
            return true;
        }
    });
};

const deleteCookie = function(cookie_name, cookie_domain) {
    document.cookie = cookie_name + '=; domain=' + cookie_domain + '; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

const clearCookies = function(cookie_name, cookie_domain) {
    //console.log('To do: Clear all cookie storage');
};


//
// Local Storage
//

const setLocalStorage = function(storage_key, storage_value) {
    if (typeof(storage_value) !== 'string') {
        storage_value = JSON.stringify(storage_value);
    }

    localStorage.setItem(storage_key, storage_value);
};

const getLocalStorage = function(storage_key) {
    return localStorage.getItem(storage_key);
};

const deleteLocalStorage = function(storage_key) {
    localStorage.removeItem(storage_key);
};

const clearLocalStorage = function() {
    localStorage.clear();
};


//
// Session Storage
//

const setSessionStorage = function(storage_key, storage_value) {
    if (typeof(storage_value) !== 'string') {
        storage_value = JSON.stringify(storage_value);
    }

    sessionStorage.setItem(storage_key, storage_value);
};

const getSessionStorage = function(storage_key) {
    return sessionStorage.getItem(storage_key);
};

const deleteSessionStorage = function(storage_key) {
    sessionStorage.removeItem(storage_key);
};

const clearSessionStorage = function() {
    sessionStorage.clear();
};
